import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApiCallsService } from '../../services/network/api-calls.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [CommonModule],
})
export class LoaderComponent implements OnInit {
  isSpinnerVisible = false;

  constructor(
    private _apiService: ApiCallsService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this._apiService.loaderState.subscribe((data: any) => {
      if (data) this.isSpinnerVisible = true;
      else this.isSpinnerVisible = false;
      this.cdr.detectChanges();
    });
  }
}
